import LogMixin from '@/mixins/log-mixin.js'
import constants from '@/constants.json'
import countryIsd from '@/countryIsd'

import { Success, Not_found } from '@/statusCodes.js'

const googleAuthReponse = {
	mixins: [LogMixin],
	methods: {
		handleGoogleAuth(method, response) {
			const { StatusCode, Data, Message } = response.data

			if (StatusCode !== Success && StatusCode !== Not_found) {
				this.snackbar = true
				this.errorMessage = Message || constants.errorMessage
				return
			}

			if (StatusCode === Not_found) {
				this.snackbar = true
				this.errorMessage = constants.invalidUser
				return
			}

			if (StatusCode === Success) {
				const { Token, UserInfo, DoctorInfo } = Data

				// const password = window.atob(UserInfo.Password) // convert base64 to raw

				this.storeUser = {
					userName: this.$CryptoJS.AES.encrypt(UserInfo.Username, this.$secretKey).toString(),
					// password: this.$CryptoJS.AES.encrypt(password, this.$secretKey).toString(),
					provider: 'google'
				}

				this.$store.commit('setUser', this.storeUser)
				this.$store.commit('setToken', Token) // Authorization Token response.data.Data.Token
				this.$store.commit('setUserId', UserInfo.Id) // Store user Id
				this.$store.commit('setUserName', DoctorInfo.Doctor_name)
				this.$store.commit('setUserEmail', UserInfo.Email)

				this.$store.commit('setUserContact', DoctorInfo.Doctor_contact)

				// method -> sign_up | login
				this.$gtag.event(method, { method: 'google' })

				if (UserInfo.AskMobileNumber) {
					this.$store.commit('verifyPhoneStore/SET_VERIFY_PHONE_STATUS', true)
					this.$router.push('/verify-phone')
				} else {
					localStorage.setItem('isLogin', true)
					this.enableLogsAPI(UserInfo.Id) // enable login api

					// has country
					if (typeof DoctorInfo.Doctor_country === 'string' && DoctorInfo.Doctor_country) {
						const { Doctor_country, IsdCode } = DoctorInfo
						const doctorCountry = `${Doctor_country.charAt(0).toUpperCase()}${Doctor_country.slice(
							1
						)}`

						if (IsdCode != null) {
							let country = countryIsd.filter(
								(x) => x.code.replace('+', '') == IsdCode.replace('+', '')
							) //get country from isdcode
							let countryName = country[0]['name']
							this.$store.commit('setUserIsd', IsdCode)
							this.$store.commit(
								'setUserCountry',
								countryName.charAt(0).toUpperCase() + countryName.slice(1)
							) // Authorization Token response.data.Data.Token
						} else {
							this.$store.commit('setUserIsd', IsdCode)
							this.$store.commit(
								'setUserCountry',
								doctorCountry.charAt(0).toUpperCase() + doctorCountry.slice(1)
							)
						}
					}

					if (DoctorInfo.Doctor_photo && DoctorInfo.Doctor_photo != 'null') {
						const pic = DoctorInfo.Doctor_photo.includes('http')
							? DoctorInfo.Doctor_photo
							: process.env.VUE_APP_API_URL_BASE + DoctorInfo.Doctor_photo

						this.$store.commit('setProfileImage', pic)
					}
					this.$root.$emit('setImage', DoctorInfo.Doctor_photo)

					this.$router.push('/dashboard') // If success then redirect to dashboard page.
				}
			}
		}
	}
}

export default googleAuthReponse
